import PropTypes from 'prop-types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useSettingsContext } from './SettingsContext';
import SvgColor from '../svg-color';

ThemeToggle.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default function ThemeToggle({ size = 'small' }) {
  const { themeMode, onChangeMode } = useSettingsContext();

  const handleChange = (event, newMode) => {
    if (newMode !== null) {
      onChangeMode({ target: { value: newMode } });
    }
  };

  return (
    <ToggleButtonGroup
      value={themeMode}
      exclusive
      onChange={handleChange}
      size={size}
      sx={{
        '& .MuiToggleButton-root': {
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '6px',
          px: 1.5,
          py: 0.5,
          minWidth: 'auto',
          '&:not(:first-of-type)': {
            marginLeft: -1,
            borderLeft: '1px solid',
            borderLeftColor: 'divider',
          },
          '&:first-of-type': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          '&:last-child': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          '&:not(:first-of-type):not(:last-child)': {
            borderRadius: 0,
          },
          '&.Mui-selected': {
            backgroundColor: 'action.selected',
            color: 'text.primary',
            '&:hover': {
              backgroundColor: 'action.selected',
            },
          },
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
      }}
    >
      <ToggleButton value="light" aria-label="light theme">
        <SvgColor
          src="/assets/icons/setting/ic_sun.svg"
          sx={{ width: 16, height: 16 }}
        />
      </ToggleButton>
      <ToggleButton value="dark" aria-label="dark theme">
        <SvgColor
          src="/assets/icons/setting/ic_moon.svg"
          sx={{ width: 16, height: 16 }}
        />
      </ToggleButton>
      <ToggleButton value="system" aria-label="system theme">
        <SvgColor
          src="/assets/icons/setting/ic_setting.svg"
          sx={{ width: 16, height: 16 }}
        />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}